// IE 11 and Edge 18 do not support Array.prototype.flatMap()
export var flatMap = function flatMap(array, callback) {
  return array.reduce(function (accumulator, item) {
    return accumulator.concat(callback(item));
  }, []);
};